// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoSaml } from '../../../assets/images/Logos/logo-saml.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoSamlIcon = /* @__PURE__ */ withLogoClass(LogoSaml);
